import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "ai",
    iconColor: "white",
    text: "AI based smart data \nquality",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "eyeFocus",
    iconColor: "white",
    text: "Reduction in cost of data \nintegration",
    listItemCustomStyle: { width: "255px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithCloud",
    iconColor: "white",
    text: "Petabyte scale reliable \ndata movement",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "autonomousManagement",
    iconColor: "white",
    text: "Autonomous quality \nreport and healing",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_DNA2_2 = {
  title: "Self-healing in Smart Data \nQuality & Assertion",
  titleNumber: "2.",
  text: "Provides proactive data quality checks and recommendation that \nensure reliable ans secure data movement.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Challenges Solved",
    onClick: () => setCurrentPage(204),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(202),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_03.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  demoButtons: [
    {
      label: "Data Streams demo",
      onClick: () => {
        setPreviousPage(203);
        setCurrentPage(205);
      },
      endIcon: "play",
    },
  ],
};
